import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import {PickingListState} from "@/interfaces/state";
import {IdMapper} from "@/interfaces/state/base";
import {PickingList} from "@/interfaces/entity";
import {PaginationMeta} from "@/interfaces/common";
import {PickingListParams} from "@/modules/pickinglists/params";
import {
    createPickingList, historyStockOut,
    listPickingListServeStockOutAndStockIn,
    singlePickingList
} from "@/modules/pickinglists/services";
import store from "@/store";
import { union } from "lodash";

@Module({ dynamic: true, name: "pickingList", store })
class PickingListModule extends VuexModule implements PickingListState {
    data: IdMapper<PickingList> = {};
    ids: number[] = [];
    meta: PaginationMeta = new PaginationMeta();
    params: any = new PickingListParams();

    @Mutation
    private MAP_PICKING_LISTS(payload: any) {
        const idMapper: IdMapper<PickingList> = {};
        this.meta = payload.meta;
        this.ids = payload.datas.map((pickingList: PickingList) => {
            idMapper[pickingList.id] = pickingList;
            return pickingList.id;
        });
        this.data = idMapper;
    }

    @Mutation
    private ADD_PICKING_LIST(payload: PickingList) {
        if (!payload) return;
        this.ids = union(this.ids, [payload.id]);
        this.data[payload.id] = {
            ...this.data[payload.id] || {},
            ...payload
        };
    }

    @Mutation
    private UPDATE_PICKING_LIST_PARAMS(payload: any) {
        this.params = payload;
    }

    @Action({ rawError: true })
    public async createPickingList(payload: any) {
        const { data } = await createPickingList(payload);
        this.ADD_PICKING_LIST(data.data);
        return data.data;
    }

    @Action({ rawError: true })
    public async listPickingListServeStockOutAndStockIn(payload: any) {
        const { data } = await listPickingListServeStockOutAndStockIn(payload);
        this.MAP_PICKING_LISTS(data);
    }

    @Action({ rawError: true })
    public async singlePickingList(payload: number) {
        const { data } = await singlePickingList(payload);
        this.ADD_PICKING_LIST(data.data);
    }

    @Action({ rawError: true })
    public async historyStockOut(params: any) {
        const { data } = await historyStockOut(params);
        this.MAP_PICKING_LISTS(data);
    }

    @Action({ rawError: true })
    public updatePickingListParams(payload: any) {
        this.UPDATE_PICKING_LIST_PARAMS(payload);
    }
}

export const PickingListStore = getModule(PickingListModule);